// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__nCcHj","signatureBlock":"Footer_signatureBlock__2zlau","signature":"Footer_signature__27I-X"};